import React from "react";
import {
  Icon,
  Segment,
  Popup,
  Button,
  Dimmer,
  Loader
} from "semantic-ui-react";

export const getTotalPeopleNumber = (info = {}) => {
  if (!info.occur) {
    return "";
  }
  const sumOfPersonCategory =
    info.personsCategoryAge1 +
    info.personsCategoryAge2 +
    info.personsCategoryAge3;
  return `( ${info.personsAdult} ${
    sumOfPersonCategory > 0 ? " + " + sumOfPersonCategory + " )" : ")"
  }`;
};
const getName = user => {
  return user.firstname && user.surname
    ? `${user.firstname} ${user.surname}`
    : user.email;
};

const getCleanerNames = cleaningList => {
  const names = cleaningList.map(cleaning => getName(cleaning.user));
  return names.join(", ");
};

const RoomBlock = props => {
  const { name, color, note } = props;
  return (
    <Segment
      as={Button}
      textAlign="center"
      color={color || "blue"}
      basic
      fluid
      onClick={props.handleClick}>
      <Dimmer active={props.loading} inverted>
        <Loader />
      </Dimmer>
      <style>{`.ui.button>.icon:not(.button) {
            height: auto;
        }
        #diabled-icon{
          background-color: lightgrey !important;
        }`}</style>
      <span style={{ fontWeight: "bold", fontSize: 17 }}>{name}</span>
      <br />
      <br />
      <Popup
        trigger={
          <span style={{ fontSize: 12, fontWeight: 2, color: "grey" }}>
            {note && note.substring(0, 20) + "..."}
          </span>
        }
        content={note || ""}
      />
      <br />
      <br />

      <Popup
        trigger={
          <Icon
            bordered
            name="add user"
            disabled={!props.arrival.occur}
            color={props.arrival.occur ? "orange" : undefined}
            inverted
            id={!props.arrival.occur ? "diabled-icon" : undefined}
          />
        }
        content={`${props.t("roomBlock:arrivalText")} ${getTotalPeopleNumber(
          props.arrival
        )}`}
      />
      <Popup
        trigger={
          <Icon
            bordered
            name="bed"
            disabled={!props.stay.occur}
            inverted
            color={props.stay.occur ? "blue" : undefined}
            id={!props.stay.occur ? "diabled-icon" : undefined}
          />
        }
        content={`${props.t("roomBlock:stayText")} ${getTotalPeopleNumber(
          props.stay
        )}`}
      />
      <Popup
        trigger={
          <Icon
            bordered
            name="remove user"
            inverted
            disabled={!props.departure.occur}
            color={props.departure.occur ? "orange" : undefined}
            id={!props.departure.occur ? "diabled-icon" : undefined}
          />
        }
        content={`${props.t("roomBlock:departureText")} ${getTotalPeopleNumber(
          props.departure
        )}`}
      />
      <Popup
        trigger={
          <Icon
            bordered
            name="female"
            disabled={props.cleaningList.length === 0}
            inverted
            color={props.cleaningList.length > 0 ? "blue" : undefined}
            id={props.cleaningList.length === 0 ? "diabled-icon" : undefined}
          />
        }
        content={`${props.t("roomBlock:scheduledCleaning")} ( ${getCleanerNames(
          props.cleaningList
        )} )`}
      />
    </Segment>
  );
};
export default RoomBlock;



// WEBPACK FOOTER //
// ./src/rooms/HotelStructure/RoomBlock.js